import { Box, Paper, useTheme } from "@mui/material";

const GlassCard = ({ children, sx = {}, hover = true, variant = "panel", ...props }) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        overflow: "hidden",
        p: { xs: 2, md: 3.5 },
        minWidth: 0,
        borderRadius: theme.custom.borderRadius,
        background: theme.custom.glass.background,
        backdropFilter: theme.custom.glass.backdropFilter,
        WebkitBackdropFilter: theme.custom.glass.backdropFilter,
        border: theme.custom.glass.border,
        boxShadow: theme.custom.glass.boxShadow,
        ...(variant === "section" && { background: "transparent", border: "none", borderRadius: 0, p: 0 }),
        transition: "border-color 150ms ease, box-shadow 150ms ease",
        ...(hover && {
          "&:hover": {
            borderColor: theme.palette.mode === "dark" ? theme.palette.divider : theme.palette.primary.main,
            boxShadow: theme.palette.mode === "dark" ? `${theme.custom.glass.boxShadow}, ${theme.custom.softGlow}` : theme.custom.glass.boxShadow,
          },
        }),
        ...sx,
      }}
      {...props}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>{children}</Box>
    </Paper>
  );
};

export default GlassCard;
